<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Contact</h3>
                    <ul class="contact-us-link">
                        <li>
                            <i class='bx bx-map'></i>
                            <a href="#" target="_blank">Agori 2, Abomey-Calavi, Atlantique, Bénin</a>
                        </li>
                        <li>
                            <i class='bx bx-phone-call'></i>
                            <a href="#">+229 97 21 37 17</a>
                        </li>
                        <li>
                            <i class='bx bx-envelope'></i>
                            <a href="mailto:hello@cacebenin.bj">hello@cacebenin.bj</a>
                        </li>
                    </ul>
                    <ul class="social-link">
                        <li><a href="https://m.facebook.com/p/Centre-dAssistance-et-de-Conseil-en-%C3%89ducation-ste-Louise-de-Sim%C3%A9on-CACE-100075852853559/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li> -->
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Support</h3>
                    <ul class="support-link">
                        <li><a routerLink="/">Vie privée</a></li>
                        <li><a routerLink="/">FAQ's</a></li>
                        <li><a routerLink="/">Termes et Conditions générales</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Navigation</h3>
                    <ul class="useful-link">
                        <li><a href="#about">Le centre</a></li>
                        <li><a routerLink="/">Nos axes</a></li>
                        <li><a routerLink="/signin">Rejoignez-nous</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Rejoingnez notre newsletter</h3>
                    <div class="newsletter-box">
                        <p>Pour recevoir les dernières nouvelles et les dernières mises à jour de notre part.</p>
                        <form class="newsletter-form">
                            <label>Votre addresse e-mail:</label>
                            <input type="email" class="input-newsletter" placeholder="Enter votre email" name="EMAIL">
                            <button type="submit">S'inscrire</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom-area">
        <div class="container">
            <div class="logo">
                <a routerLink="/" class="d-inline-block"><img src="assets/img/logo2-cace-sf.png" alt="image"></a>
            </div>
            <div class="logo">
                <a routerLink="/" class="d-inline-block" style="margin-right: 15px !important;"><img src="assets/images/new/footer/_Facebook.jpg" alt="image"></a>
                <a routerLink="/" class="d-inline-block" style="margin-right: 15px !important;"><img src="assets/images/new/footer/_Linkedin.jpg" alt="image"></a>
                <a routerLink="/" class="d-inline-block" style="margin-right: 15px !important;"><img src="assets/images/new/footer/Vector.jpg" alt="image"></a>
                <a routerLink="/" class="d-inline-block" style="margin-right: 15px !important;"><img src="assets/images/new/footer/_Instagram.jpg" alt="image"></a>
            </div>
            <p>© C.A.C.E. {{year}}. Propulsé par <a href="#" target="_blank">MeKoe Technology</a></p>
        </div>
    </div>
</footer>

<ngx-scrolltop></ngx-scrolltop>